import { Link } from "react-router";
import { BRAND } from "../constants/config";

export default function BrandLogo({
  className = "h-10 sm:h-12",
  linkTo = "/",
}) {
  const image = (
    <img
      src={BRAND.logo}
      alt={BRAND.logoAlt}
      className={`w-auto rounded-lg ${className}`}
    />
  );

  if (!linkTo) {
    return image;
  }

  return (
    <Link to={linkTo} className="inline-block hover:opacity-90 transition">
      {image}
    </Link>
  );
}
